import type { PortableTextTypeComponent } from '@portabletext/react';
import groq from 'groq';

import type { LelandImage } from '../../../types/cmsTypes';
import SanityImage, {
  SANITY_IMAGE_PROJECTION,
  SanityImageHtml,
} from '../../image/SanityImage';

const FLOATED_IMAGE_TYPE = 'floatedImage';
export const FLOATED_IMAGE_MARK_DEFS_SELECTION = groq`_type == "${FLOATED_IMAGE_TYPE}" => {
  ...,
  image {${SANITY_IMAGE_PROJECTION}}
}`;

interface Props {
  _type: typeof FLOATED_IMAGE_TYPE;
  float: 'left' | 'right';
  image: LelandImage;
}

const FloatedImage: PortableTextTypeComponent<Props> = ({
  value: { float, image } = {},
}) => {
  if (!image) {
    return null;
  }

  const floatClasses =
    float === 'right' ? 'float-right mr-0' : 'float-left ml-0';

  return (
    <div className={`m-6 w-full md:w-5/12 ${floatClasses}`}>
      <SanityImage
        className="rounded-xl"
        image={image}
        alt=""
        sizes={{ md: '42vw', dflt: '100vw' }}
      />
    </div>
  );
};

export default FloatedImage;

export const FloatedImageHtml: PortableTextTypeComponent<Props> = ({
  value: { image } = {},
}) => {
  if (!image) {
    return null;
  }

  return (
    <div>
      <SanityImageHtml
        image={image}
        alt=""
        sizes={{
          md: '42vw',
          dflt: '100vw',
        }}
      />
    </div>
  );
};
